export const PAY_ORDER_STATUS = {
  PENDING_ORDER: "pending_order",
  PENDING_PURCHASE_AUDIT: "pending_purchase_audit",
  PENDING_PAYMENT: "pending_payment",
  PENDING_PAYMENT_AUDIT: "pending_payment_audit",
  PAYMENT_COMPLETED: "payment_completed",
  VOID: "void",
};

export const PAY_ORDER_SOURCE_TYPE = {
  PURCHASE: "purchase",
  PURCHASE_ORDER: "purchaseOrder",
};

export const PAY_ORDER_SOURCE_TYPE_LABEL = {
  [PAY_ORDER_SOURCE_TYPE.PURCHASE]: "旧采购",
  [PAY_ORDER_SOURCE_TYPE.PURCHASE_ORDER]: "采购单",
};

export const PAY_ORDER_SOURCE_TYPE_FILTER_OPTIONS = [
  { label: "全部", value: "" },
  { label: PAY_ORDER_SOURCE_TYPE_LABEL[PAY_ORDER_SOURCE_TYPE.PURCHASE], value: PAY_ORDER_SOURCE_TYPE.PURCHASE },
  {
    label: PAY_ORDER_SOURCE_TYPE_LABEL[PAY_ORDER_SOURCE_TYPE.PURCHASE_ORDER],
    value: PAY_ORDER_SOURCE_TYPE.PURCHASE_ORDER,
  },
];

export const PAY_ORDER_SOURCE_TYPE_CAPABILITIES = {
  [PAY_ORDER_SOURCE_TYPE.PURCHASE]: {
    canInvoice: true,
    canViewSourceRecords: true,
    canViewSourceMaterials: true,
    sourceRecordLabel: "采购记录",
    sourceMaterialLabel: "采购材料",
  },
  [PAY_ORDER_SOURCE_TYPE.PURCHASE_ORDER]: {
    canInvoice: true,
    canViewSourceRecords: true,
    canViewSourceMaterials: true,
    sourceRecordLabel: "采购单明细",
    sourceMaterialLabel: "采购材料",
  },
};

export function normalizePayOrderSourceType(value) {
  if (value == null || value === "") {
    return PAY_ORDER_SOURCE_TYPE.PURCHASE;
  }
  const raw = String(value).trim();
  if (PAY_ORDER_SOURCE_TYPE_LABEL[raw]) {
    return raw;
  }
  return PAY_ORDER_SOURCE_TYPE.PURCHASE;
}

export function getPayOrderSourceTypeLabel(sourceType) {
  const code = normalizePayOrderSourceType(sourceType);
  return PAY_ORDER_SOURCE_TYPE_LABEL[code] || code;
}

export function getPayOrderSourceCapabilities(sourceType) {
  const code = normalizePayOrderSourceType(sourceType);
  return (
    PAY_ORDER_SOURCE_TYPE_CAPABILITIES[code] || PAY_ORDER_SOURCE_TYPE_CAPABILITIES[PAY_ORDER_SOURCE_TYPE.PURCHASE]
  );
}

export const PAY_ORDER_STATUS_LABEL = {
  [PAY_ORDER_STATUS.PENDING_ORDER]: "待下单",
  [PAY_ORDER_STATUS.PENDING_PURCHASE_AUDIT]: "待采购审核",
  [PAY_ORDER_STATUS.PENDING_PAYMENT]: "待付款",
  [PAY_ORDER_STATUS.PENDING_PAYMENT_AUDIT]: "待支付审核",
  [PAY_ORDER_STATUS.PAYMENT_COMPLETED]: "付款完成",
  [PAY_ORDER_STATUS.VOID]: "已作废",
};

export const PAY_ORDER_STATUS_PASS_BUTTON_LABEL = {
  [PAY_ORDER_STATUS.PENDING_ORDER]: "确认下单",
  [PAY_ORDER_STATUS.PENDING_PURCHASE_AUDIT]: "审核通过",
  [PAY_ORDER_STATUS.PENDING_PAYMENT]: "确认付款",
  [PAY_ORDER_STATUS.PENDING_PAYMENT_AUDIT]: "审核通过",
};

export const PAY_ORDER_STATUS_REJECT_TARGET = {
  [PAY_ORDER_STATUS.PENDING_PURCHASE_AUDIT]: PAY_ORDER_STATUS.PENDING_ORDER,
  [PAY_ORDER_STATUS.PENDING_PAYMENT]: PAY_ORDER_STATUS.PENDING_PURCHASE_AUDIT,
  [PAY_ORDER_STATUS.PENDING_PAYMENT_AUDIT]: PAY_ORDER_STATUS.PENDING_PAYMENT,
};

export const PAY_ORDER_REVIEWABLE_STATUSES = [
  PAY_ORDER_STATUS.PENDING_ORDER,
  PAY_ORDER_STATUS.PENDING_PURCHASE_AUDIT,
  PAY_ORDER_STATUS.PENDING_PAYMENT,
  PAY_ORDER_STATUS.PENDING_PAYMENT_AUDIT,
];

export const PAY_ORDER_STATUS_FILTER_OPTIONS = [
  { label: "全部", value: "" },
  { label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.PENDING_ORDER], value: PAY_ORDER_STATUS.PENDING_ORDER },
  { label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.PENDING_PURCHASE_AUDIT], value: PAY_ORDER_STATUS.PENDING_PURCHASE_AUDIT },
  { label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.PENDING_PAYMENT], value: PAY_ORDER_STATUS.PENDING_PAYMENT },
  { label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.PENDING_PAYMENT_AUDIT], value: PAY_ORDER_STATUS.PENDING_PAYMENT_AUDIT },
  { label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.PAYMENT_COMPLETED], value: PAY_ORDER_STATUS.PAYMENT_COMPLETED },
  { label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.VOID], value: PAY_ORDER_STATUS.VOID },
];

export const PAY_ORDER_STATUS_TABS = [
  { name: "all", label: "全部", showBadge: false },
  { name: PAY_ORDER_STATUS.PENDING_ORDER, label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.PENDING_ORDER], showBadge: true },
  { name: PAY_ORDER_STATUS.PENDING_PURCHASE_AUDIT, label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.PENDING_PURCHASE_AUDIT], showBadge: true },
  { name: PAY_ORDER_STATUS.PENDING_PAYMENT, label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.PENDING_PAYMENT], showBadge: true },
  { name: PAY_ORDER_STATUS.PENDING_PAYMENT_AUDIT, label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.PENDING_PAYMENT_AUDIT], showBadge: true },
  { name: PAY_ORDER_STATUS.PAYMENT_COMPLETED, label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.PAYMENT_COMPLETED], showBadge: false },
  { name: PAY_ORDER_STATUS.VOID, label: PAY_ORDER_STATUS_LABEL[PAY_ORDER_STATUS.VOID], showBadge: false },
];

export function getPayOrderStatusTagType(status) {
  const map = {
    [PAY_ORDER_STATUS.PENDING_ORDER]: "info",
    [PAY_ORDER_STATUS.PENDING_PURCHASE_AUDIT]: "warning",
    [PAY_ORDER_STATUS.PENDING_PAYMENT]: "danger",
    [PAY_ORDER_STATUS.PENDING_PAYMENT_AUDIT]: "warning",
    [PAY_ORDER_STATUS.PAYMENT_COMPLETED]: "success",
    [PAY_ORDER_STATUS.VOID]: "info",
  };
  return map[status] || "";
}
